import { themeQuartz } from "ag-grid-community";

export const standardTheme = themeQuartz.withParams({
  headerHeight: "30px",
  headerTextColor: "white",
  headerBackgroundColor: "#0099ab",
});
